import { TankType } from '../../types/apiResponse/tankSpecTypes'
import { getData } from '../../utils'

export const getTankById = async (tankId: string) => {
  return await getData<TankType>(`tank/${tankId}`)
}
